import { PatientConsentsEffects } from '@patient-store/effects/consents.effects';

export const patientEffects = [
	PatientConsentsEffects,
];
